var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNavDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#434345;opacity:0.01;isolation:isolate;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,12a4,4,0,0,0-8,0V75L22.86,51.58A4,4,0,0,0,17,57L43,85.81c.11.12.23.24.35.35a6.78,6.78,0,0,0,9.28,0q.19-.18.36-.36L78.87,57A4,4,0,1,0,73,51.58L52,74.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNavDown);
export default __webpack_public_path__ + "static/media/arrow-nav-down.bc1e1bdbab8e9b61eed8e6a525884461.svg";
export { ForwardRef as ReactComponent };